import api from "./axios";
class ServiceBillFile {
  async deleteFile(id) {
    await api.delete(`/bill-file/${id}`)
  }

  async signedUrls(urls) {
    const { data } = await api.post(`/bill-file/signed-urls`, { urls })

    return data
  }
}

export default new ServiceBillFile()